





















import Vue from 'vue';
export default Vue.extend({
  name: 'DashboardButton',
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    routeName: {
      type: String,
      required: true
    },
    routeParams: {
      type: Object,
      default: () => ({})
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hover: false
    };
  },
  methods: {
    onDashboardButtonClick() {
      if (this.isDisabled) {
        return;
      }
      this.$router.push({ name: this.routeName, params: this.routeParams });
    }
  },
  computed: {
    buttonCss(): string {
      return `card-body h-100 ${this.hoveringAndEnabled ? 'pointer bg-light-gray' : ''} ${
        this.isDisabled ? 'bg-light-gray text-muted' : ''
      }`;
    },
    iconBackgroundCss(): string {
      return `col-md-4 text-center rounded-left bg-primary ${this.isDisabled ? 'opacity-65' : ''}`;
    },
    iconCss(): string {
      return `d-flex h-100 justify-content-center align-items-center p-3 ${this.hoveringAndEnabled ? 'pointer' : ''}`;
    },
    hoveringAndEnabled(this: any) {
      return this.hover && !this.isDisabled;
    }
  }
});
